var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chamomileApp" },
    [
      _vm.isLoading
        ? _c("div", { staticClass: "nowLoading" }, [
            _vm._v("データを読み込み中...")
          ])
        : _c("router-view"),
      _vm._v(" "),
      _vm.errorStatus
        ? _c("redirect-dialog", {
            tag: "component",
            staticClass: "reveal-overlay",
            attrs: { errorData: _vm.errorStatus }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("notifications-panel")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }